import BlockedUsers from "../../components/blocked-users";
import HeaderPage from "../../components/lines-managements/header/HeaderPage";

const BlockedUsersPage: React.FC = () => {
  return (
    <>
      <HeaderPage
        link={{
          to: "add",
          children: "Shto përdorues në listë të zezë",
          state: ["Blocked Users", "Blloko përdoruesin"]
        }}
      />
      <BlockedUsers />
    </>
  );
};

export default BlockedUsersPage;
